import { api } from '@/lib/api/client';

export type LegalDocumentType =
  | 'platform_tos'
  | 'platform_privacy'
  | 'data_controller_ack'
  | 'dpa'
  | 'tcpa'
  | 'reporter_terms';

export interface LegalAcceptance {
  id: number;
  documentType: LegalDocumentType;
  documentVersion: string;
  versionHash: string;
  brandId: number | null;
  signerName: string | null;
  signerTitle: string | null;
  locale: string;
  acceptedAt: string;
}

export const legalApi = {
  check: (
    documentType: LegalDocumentType,
    versionHash: string,
    brandId?: number,
  ) =>
    api.get<LegalAcceptance | null>('/co-legal-acceptance/check', {
      params: { documentType, versionHash, brandId },
    }),

  mine: () => api.get<LegalAcceptance[]>('/co-legal-acceptance/mine'),

  record: (input: {
    documentType: LegalDocumentType;
    documentVersion: string;
    versionHash: string;
    brandId?: number;
    signerName?: string;
    signerTitle?: string;
    locale?: string;
  }) => api.post<LegalAcceptance>('/co-legal-acceptance', input),
};
